import {Clock, WebGLRenderer} from "three";

export default class Renderer extends WebGLRenderer
{
    scene = null;

    clock = new Clock;

    camera = null;

    callbackUpdate = null;

    constructor(scene, camera, root, sizes) {
        super({antialias: true, alpha: true});
        this.scene = scene;
        this.camera = camera;
        this.shadowMap.enabled = false;
        this.setSize( sizes.width, sizes.height );
        this.setPixelRatio( window.devicePixelRatio * 0.55 );
        this.setClearColor( 0x000000, 0 );
        root.appendChild( this.domElement );

        let last_time = 0;

        const raf = async time => {
            if ( document.hasFocus && time - last_time > 60 ) {
                last_time = time;
                const delta = this.clock.getDelta();

                if ( this.callbackUpdate ) {
                    this.callbackUpdate( {time, delta} );
                }

                await this.render( this.scene, this.camera );
            }

            window.requestAnimationFrame( raf );
        };

        window.requestAnimationFrame( raf );
    }

    onUpdate(callback) {
        this.callbackUpdate = callback;

        return this;
    }
}